import axios from "axios";
import { SAVED_JOB_REQUESTS_URL } from "../utils";

export const fetchSavedJobRequests = async () => {
  return axios.get(SAVED_JOB_REQUESTS_URL);
};
